<template>
  <div class="vertical-toolbar">
    <q-list padding>
      <q-item clickable v-ripple :to="{ name: 'home' }" data-dd-action-name="Vertical NavBar: open home page action">
        <q-item-section avatar>
          <q-icon :style="path === '/' ? 'color: #74C2C0' : 'color: #9b8ea8'" name="home" />
        </q-item-section>

        <q-item-section>
          <div :style="path === '/' ? 'color: #74C2C0' : 'color: #9b8ea8'">Home</div>
        </q-item-section>
      </q-item>

      <q-item
        clickable
        v-ripple
        :to="{ name: 'search' }"
        active-class="main_button__selection"
        data-dd-action-name="Vertical NavBar: open search page action"
      >
        <q-item-section avatar>
          <q-icon name="search" />
        </q-item-section>

        <q-item-section> Search </q-item-section>
      </q-item>

      <q-item
        clickable
        v-ripple
        id="policiesNavBarItem"
        :to="{ name: 'policiesPage' }"
        active-class="main_button__selection"
        data-dd-action-name="Vertical NavBar: open policies page action"
      >
        <q-item-section avatar>
          <q-icon name="view_list" />
        </q-item-section>

        <q-item-section> Policies </q-item-section>
      </q-item>

      <q-item
        clickable
        v-ripple
        id="rulesNavBarItem"
        :to="{ name: 'rulesPage' }"
        active-class="main_button__selection"
        data-dd-action-name="Vertical NavBar: open rules page action"
      >
        <q-item-section avatar>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            height="25"
            width="25"
            :style="path === '/rules' ? 'stroke: #74C2C0' : 'stroke:#9b8ea8'"
          >
            <path
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="32"
              d="M160 368L32 256l128-112M352 368l128-112-128-112"
            />
          </svg>
        </q-item-section>

        <q-item-section> Rules </q-item-section>
      </q-item>

      <q-item
        clickable
        v-ripple
        id="userFunctionsNavBarItem"
        :to="{ name: 'userFunctionsPage' }"
        active-class="main_button__selection"
        data-dd-action-name="Vertical NavBar: open functions page action"
      >
        <q-item-section avatar>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            height="25"
            width="25"
            :style="path === '/user_functions' ? 'fill: #74C2C0' : 'fill: #9b8ea8'"
          >
            <title>Code Working</title>
            <circle cx="256" cy="256" r="26" />
            <circle cx="346" cy="256" r="26" />
            <circle cx="166" cy="256" r="26" />
            <path
              fill="none"
              :style="path === '/user_functions' ? 'stroke: #74C2C0' : 'stroke: #9b8ea8'"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="32"
              d="M160 368L32 256l128-112M352 368l128-112-128-112"
            />
          </svg>
        </q-item-section>

        <q-item-section> Functions </q-item-section>
      </q-item>
    </q-list>

    <div class="logo-wrapper">
      <q-separator inset color="accent" />
      <img v-if="!mini" src="@/assets/images/Iris-logo.png" class="iris-logo" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables'

export default defineComponent({
  props: {
    mini: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const route = useRoute()
    const path = computed(() => route.path)

    return { path }
  },
})
</script>
<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.vertical-toolbar {
  display: flex;
  flex-direction: column;
  background-color: $primary;
  color: $primary-lighter;
  min-height: 100%;
}

.main_button__selection {
  color: $accent;
}

.logo-wrapper {
  align-self: center;
}

.iris-logo {
  width: 10em;
  margin: 4rem $space-x-sm $space-x-xs $space-x-xs;
  pointer-events: none;
}
</style>
